import BaseStore from './BaseStore'

export class WorkflowStore extends BaseStore {
  constructor() {
    super()
    this.endpoint = 'workflows'
  }
}

export default new WorkflowStore()


// WEBPACK FOOTER //
// ./src/stores/WorkflowStore.js